import { Component, Input, OnInit } from '@angular/core';
import { IPolicy } from 'src/app/features/policies/interfaces/policy.interface';

@Component({
  selector: 'app-policy-item',
  templateUrl: './policy-item.component.html',
  styleUrls: ['./policy-item.component.scss'],
})
export class PolicyItemComponent {
 @Input() policy: IPolicy;
  constructor() { }

}
